import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import SideBar from "./SideBar";
import MyTabs from "./Tabs";
// import OnboardingScreen from "../../common/OnboardingScreen/OnboardingScreen";
import Topics from "./Topics/Topics";
import AlertPopUp from "../../common/AlertPopUp";
import MarketPlaceSideBar from "../MarketPlace/MarketPlaceSideBar";
import useChatState from "../../customHooks/useChatState";
import { useTranslation } from "react-i18next";
import InternalInvitieTooltip from "../../common/ToolTip/InternalInvitieTooltip";
import ExternalAccountGroupInviteTooltip from "../../common/ToolTip/ExternalAccountGroupInviteTooltip";
import { fetchToken } from "../../config/firebase.config";

const classes = {
  chatComponent: {
    height: "calc(100vh - 4rem)",
    "@media (max-width: 1194px)": {
      height: "69%",
    },
  },
  chatBox1: {
    minWidth: "26%",
    maxWidth: "26%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    "@media (max-width: 1194px)": {
      height: "69%",
    },
  },
  taskApprovalSidebar: {
    minWidth: "26%",
    maxWidth: "26%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    "@media (max-width: 1194px)": {
      height: "calc(100vh - 6rem)",
    },
  },
  chatBox2: {
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 64px)",
    minWidth: "19%",
    maxWidth: "19%",
    "@media (max-width: 1194px)": {
      height: "69%",
    },
  },
};

const Chat = ({
  setisTopicOpen,
  isTopicOpen,
  handleCloseAddPeopleDrawer,
  isAddPeopledarwer,
  setAddpeopledarwer,
  setPricingDrawerOpen,
  groupname,
  setGroupname,
  pubnub,
}) => {
  const {
    isCreategroupOpen,
    setCreategroupopen,
    isRequired,
    currentUserData,
    dmUserDeatils,
    isMoveTopicTriggered,
    setMoveTopicTriggered,
    moveTopicMsgId,
    setMoveTopicMsgId,
    isPermissionModalOpen,
    setPermissionModal,
    newMessages,
    setNewMessages,
    filterChecked,
    setFilterChecked,
    currentHomeIndexTab,
    showSidebar,
    setShowSidebar,
    setAiQueryHistory,
    setShareAiText,
    isShareAiText,
    isAiQueryHistory,
    handlegroupItemclick,
    handleFlipToArchiveGroupList,
    handlecreategroup,
    handlecloseCreategroup,
    handleNameChange,
    handleDescriptionChange,
    handlesavearkchatgroup,
    handleSelectedTopic,
    newGroupName,
    setNewGroupName,
    newGroupDescription,
    setNewGroupDescription,
    isSyncing,
  } = useChatState({
    setisTopicOpen,
    isTopicOpen,
    setGroupname,
    groupname,
  });
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isSellerTabLoading, setSellerTabLoading] = useState(false);
  const [isSideBarOpen, setSideBarOpen] = useState(true);
  const endpoint = window.location.pathname;
  useEffect(() => {
    if (currentUserData?.id) {
      fetchToken(currentUserData?.id);
    }
  }, [currentUserData?.id]);

  return (
    <>
      <AlertPopUp
        title={"Access Denied ."}
        bodyContent={appContent?.KEY167}
        open={isPermissionModalOpen}
        closeModal={setPermissionModal}
      />
      {/* This is for onboarding welcome tooltip, if come as internal member */}
      {currentUserData &&
        !currentUserData?.tooltipWelcomeJourneyCompletedWeb &&
        currentUserData?.activeSubscriber?.accountOwner !==
          currentUserData?.id &&
        currentUserData?.tooltipFirstInviteScreenWeb === 1 && (
          <>
            <InternalInvitieTooltip />
          </>
        )}

      {/* This is for onboarding welcome tooltip, if come as external member */}

      {currentUserData &&
        !currentUserData?.tooltipWelcomeJourneyCompletedWeb &&
        currentUserData?.tooltipFirstInviteScreenWeb === 2 &&
        !currentUserData?.isFirstGroupCreated && (
          <>
            <ExternalAccountGroupInviteTooltip />
          </>
        )}
      <Box height={"100%"}>
        <Stack height={"100%"} direction="row" spacing={1}>
          {currentHomeIndexTab === 0 && (
            <>
              {/* Group SideBar */}

              <Box sx={classes.chatBox1}>
                <SideBar
                  setisTopicOpen={setisTopicOpen}
                  handlecreategroup={handlecreategroup}
                  handlegroupItemclick={handlegroupItemclick}
                  handleFlipToArchiveGroupList={handleFlipToArchiveGroupList}
                />
              </Box>
              {isTopicOpen && (
                <Box sx={classes.chatBox2}>
                  <Topics
                    setisTopicOpen={setisTopicOpen}
                    handleSelectedTopic={handleSelectedTopic}
                    setMoveTopicTriggered={setMoveTopicTriggered}
                    isMoveTopicTriggered={isMoveTopicTriggered}
                    moveTopicMsgId={moveTopicMsgId}
                    setMoveTopicMsgId={setMoveTopicMsgId}
                  />
                </Box>
              )}
            </>
          )}


          {currentHomeIndexTab === 3 && isSideBarOpen && (
            <>
              <Box sx={classes.chatBox1}>
                <MarketPlaceSideBar
                  setSideBarOpen={setSideBarOpen}
                  setSellerTabLoading={setSellerTabLoading}
                  isSellerTabLoading={isSellerTabLoading}
                />
              </Box>
            </>
          )}

          <Box
            sx={classes?.chatComponent}
            // height={"100%"}
            maxWidth={
              endpoint === "/chat" && currentHomeIndexTab === 0 && !isTopicOpen
                ? "73.5%"
                : endpoint === "/chat" && currentHomeIndexTab !== 0
                ? "100%"
                : "53.7%"
            }
            flex={5.2}
          >
            <MyTabs
              setSellerTabLoading={setSellerTabLoading}
              isSellerTabLoading={isSellerTabLoading}
              setisTopicOpen={setisTopicOpen}
              isTopicOpen={isTopicOpen}
              isCreategroupOpen={isCreategroupOpen}
              handleClosegroupdrawer={handlecloseCreategroup}
              handlesavearkchatgroup={handlesavearkchatgroup}
              groupname={groupname}
              setGroupname={setGroupname}
              newGroupName={newGroupName}
              newGroupDescription={newGroupDescription}
              setNewGroupDescription={setNewGroupDescription}
              setNewGroupName={setNewGroupName}
              isRequired={isRequired}
              handleNameChange={handleNameChange}
              handleDescriptionChange={handleDescriptionChange}
              dmUserDeatils={dmUserDeatils}
              isMoveTopicTriggered={isMoveTopicTriggered}
              setMoveTopicTriggered={setMoveTopicTriggered}
              setMoveTopicMsgId={setMoveTopicMsgId}
              setNewMessages={setNewMessages}
              newMessages={newMessages}
              isSyncing={isSyncing}
              pubnub={pubnub}
              setShowSidebar={setShowSidebar}
              filterChecked={filterChecked}
              setFilterChecked={setFilterChecked}
              isAiQueryHistory={isAiQueryHistory}
              setAiQueryHistory={setAiQueryHistory}
              setShareAiText={setShareAiText}
              isShareAiText={isShareAiText}
              setcreategroupopen={setCreategroupopen}
              setAddpeopledarwer={setAddpeopledarwer}
              setPricingDrawerOpen={setPricingDrawerOpen}
              isAddPeopledarwer={isAddPeopledarwer}
              handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
              isSideBarOpen={isSideBarOpen}
              setSideBarOpen={setSideBarOpen}
            />
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default Chat;
